<template>
    <div>
        <button class="group_item" :class="{'selected': this.group.isSelected }" @click="action_SelectItem">
                {{ groupTitleString }}
        </button>
    </div>
</template>

<script>
export default {
    props: { 
        group: Object,
        index: Number,
    },
    watch: {

    },
    mounted() {

    },
    computed: {
        groupTitleString: function() {
            return this.group.title ?? '-'
        }
    },
    methods: {
        action_SelectItem() {
            this.$emit('action_SelectItem', this.group)
        }
    }
}
</script>